/* Dizzle content pages. 1) Rebuilds Shopify's built-in policy pages into the Dizzle layout. 2) Wraps wide tables. 3) Marks the current section in the side list. */
(function(){
  function policy(){
    var c=document.querySelector('.shopify-policy__container');
    if(!c||c.classList.contains('dz-pol'))return;
    var t=c.querySelector('.shopify-policy__title'),b=c.querySelector('.shopify-policy__body');
    if(!t||!b)return;
    var h1=t.querySelector('h1');
    var hero=document.createElement('div');hero.className='dz-hero';
    hero.innerHTML='<div class="dz-wrap dz-hero__in"><div class="dz-hero__main"><div class="dz-crumb"><a href="/">Home</a> &nbsp;/&nbsp; <span></span></div><div class="dz-rule"></div></div></div>';
    hero.querySelector('.dz-crumb span').textContent=h1?h1.textContent:'';
    if(h1)hero.querySelector('.dz-hero__main').appendChild(h1);
    var body=document.createElement('div');body.className='dz-wrap dz-body';
    var prose=document.createElement('div');prose.className='dz-prose';
    var rte=b.querySelector('.rte')||b;
    while(rte.firstChild)prose.appendChild(rte.firstChild);
    var hs=prose.querySelectorAll('h2');
    if(hs.length>1){
      var nav=document.createElement('nav');nav.className='dz-nav';nav.setAttribute('aria-label','On this page');
      nav.innerHTML='<div class="dz-eyebrow">On this page</div>';
      hs.forEach(function(h,i){if(!h.id)h.id='dz-s'+(i+1);var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;nav.appendChild(a)});
      body.appendChild(nav);
    }else{body.classList.add('dz-body--solo')}
    body.appendChild(prose);
    c.innerHTML='';c.classList.add('dz','dz-pol');c.appendChild(hero);c.appendChild(body);
  }
  function tables(){
    document.querySelectorAll('.dz-prose table').forEach(function(t){
      if(t.parentNode.classList.contains('dz-tablebox'))return;
      var w=document.createElement('div');w.className='dz-tablebox';t.parentNode.insertBefore(w,t);w.appendChild(t);
    });
  }
  function spy(){
    var links=[].slice.call(document.querySelectorAll('.dz-nav a[href^="#"]'));
    if(!links.length)return;
    links[0].classList.add('is-on');
    if(!('IntersectionObserver' in window))return;
    var map={};
    links.forEach(function(a){var s=document.getElementById(a.getAttribute('href').slice(1));if(s)map[s.id]=a});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&map[e.target.id]){links.forEach(function(l){l.classList.remove('is-on')});map[e.target.id].classList.add('is-on')}})},{rootMargin:'-15% 0px -70% 0px'});
    Object.keys(map).forEach(function(id){io.observe(document.getElementById(id))});
  }
  function run(){if(window.__dzPagesRan)return;window.__dzPagesRan=true;policy();tables();spy()}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
